<template>
  <v-navigation-drawer v-if="isLoggedIn" app clipped :value="isOnDrawer" width="dynamicDrawerWidth">
    <v-list nav dense>

      <v-list-item>
        <v-list-item-content>
          <!-- MyPageのテキストとアイコン -->
          <v-list-item link to="/my-page" class="pa-0"> <!-- paddingを0にして、外側のv-list-itemと高さを調整 -->
            <v-list-item-icon class="mr-4">
              <v-icon large color="">mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="font-weight: bold">設定</v-list-item-title>
          </v-list-item>
        </v-list-item-content>
        <!-- <ボタンはMyPageリンクの外側に配置し、@click.stopで開閉のみを制御 -->
        <v-list-item-action style="max-width: 10px; min-width: 10px;">
          <v-btn icon small @click.stop="toggleDrawer">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-divider></v-divider>

      <!-- メインコンテンツ  -->
      <v-list-item v-for="obj in mainContents.filter((obj) => users.is_admin || !adminOnly.includes(obj.link))" :key="obj.title" :to="obj.link" link>
        <v-list-item-icon>
          <!-- 修正点1: v-list-item-icon内部にのみアイコン表示ロジックを配置 -->
          <template v-if="obj.icon === mdiRobotHappy">
            <svg-icon type="mdi" :path="obj.icon" :color="obj.color"></svg-icon>
          </template>
          <template v-else>
            <v-icon :color="obj.color">{{ obj.icon }}</v-icon>
          </template>
        </v-list-item-icon>
        <v-list-item-title v-text="obj.title"></v-list-item-title>
      </v-list-item>

      <!-- チュートリアル -->
      <v-list-item link @click="openTutorialDialog">
        <v-list-item-icon>
          <v-icon color="">mdi-school</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="font-weight-medium">チュートリアル</v-list-item-title>
      </v-list-item>

      <!-- お問い合わせリンク（ダイアログではなくページ遷移） -->
      <v-list-item link to="/contact">
        <v-list-item-icon>
          <svg-icon type="mdi" :path="mdiCommentQuestion" color=""></svg-icon>
        </v-list-item-icon>
        <v-list-item-title class="font-weight-medium">お問い合わせ</v-list-item-title>
      </v-list-item>

      <!-- ログアウト -->
      <v-list-item link @click="logoutDialog = true">
        <v-list-item-icon>
          <v-icon color="indigo lighten-2">mdi-logout-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="font-weight-medium">Logout</v-list-item-title>
      </v-list-item>

      <!-- お問い合わせフォームダイアログ -->
      <v-dialog v-model="contactDialog" max-width="600px">
        <v-card>
          <v-card-text>
            <!-- HubSpotフォームがマウントされる場所 -->
            <div id="hubspot-form-container"></div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="contactDialog = false">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- チュートリアル選択ダイアログ -->
      <v-dialog
        v-model="tutorialDialog"
        max-width="600"
        transition="dialog-bottom-transition"
        overlay-color="#1a1f33"
        overlay-opacity="0.85"
      >
        <v-card
          class="rounded-xl elevation-24"
          style="background: linear-gradient(135deg, #2c3e70 0%, #34495e 50%, #2c3e70 100%); color: #fff; overflow: hidden; position: relative;"
        >
          <!-- 装飾的な背景パターン -->
          <div class="bg-pattern-1" style="position: absolute; top: 0; right: 0; width: 200px; height: 200px; background: radial-gradient(circle, rgba(255,255,255,0.05) 0%, transparent 70%); border-radius: 50%; transform: translate(30%, -30%);"></div>
          <div class="bg-pattern-2" style="position: absolute; bottom: 0; left: 0; width: 150px; height: 150px; background: radial-gradient(circle, rgba(255,255,255,0.04) 0%, transparent 70%); border-radius: 50%; transform: translate(-30%, 30%);"></div>

          <v-card-title class="justify-center pa-6 pb-4" style="position: relative; z-index: 1;">
            <div class="text-center" style="width: 100%;">
              <v-icon color="rgba(255,255,255,0.9)" size="48" class="mb-3">mdi-school</v-icon>
              <div class="text-h5 font-weight-bold mb-1" style="text-shadow: 0 2px 8px rgba(0,0,0,0.3);">チュートリアルを選んでください</div>
              <div class="text-caption mt-2" style="color: rgba(255,255,255,0.7);">各機能の使い方を学びましょう</div>
            </div>
          </v-card-title>

          <v-card-text class="pa-6 pt-2" style="position: relative; z-index: 1;">
            <v-row no-gutters>
              <v-col cols="12" sm="6" class="pa-2">
                <v-btn
                  block
                  rounded
                  :class="['tutorial-btn', 'tutorial-responsive-btn', { 'tutorial-completed': tutorialCompleted }]"
                  @click="startResultTutorial"
                >
                  <div class="tutorial-content">
                    <v-icon class="tutorial-icon">{{ tutorialCompleted ? 'mdi-check-circle' : 'mdi-file-check-outline' }}</v-icon>
                    <span class="tutorial-step">Step 1</span>
                    <span class="tutorial-title">テンプレート機能</span>
                  </div>
                </v-btn>
              </v-col>

              <v-col cols="12" sm="6" class="pa-2">
                <v-btn
                  block
                  rounded
                  :disabled="!isStep2Enabled"
                  :class="['tutorial-btn', 'tutorial-responsive-btn', { 'tutorial-completed': extractTutorialCompleted }]"
                  @click="startExtractTutorial"
                >
                  <div class="tutorial-content">
                    <v-icon class="tutorial-icon">{{ extractTutorialCompleted ? 'mdi-check-circle' : 'mdi-robot' }}</v-icon>
                    <span class="tutorial-step">Step 2</span>
                    <span class="tutorial-title">データ収集</span>
                  </div>
                </v-btn>
              </v-col>

              <v-col cols="12" sm="6" class="pa-2">
                <v-btn
                  block
                  rounded
                  :disabled="!isStep3Enabled"
                  :class="['tutorial-btn', 'tutorial-responsive-btn', { 'tutorial-completed': schedulerTutorialCompleted }]"
                  @click="startTutorial('scheduler')"
                >
                  <div class="tutorial-content">
                    <v-icon class="tutorial-icon">{{ schedulerTutorialCompleted ? 'mdi-check-circle' : 'mdi-clock-outline' }}</v-icon>
                    <span class="tutorial-step">Step 3</span>
                    <span class="tutorial-title">定期設定</span>
                  </div>
                </v-btn>
              </v-col>

              <v-col cols="12" sm="6" class="pa-2">
                <v-btn
                  block
                  rounded
                  :disabled="!isStep4Enabled"
                  :class="['tutorial-btn', 'tutorial-responsive-btn', { 'tutorial-completed': schedulerShareCompleted }]"
                  @click="startShareTutorial"
                >
                  <div class="tutorial-content">
                    <v-icon class="tutorial-icon">{{ schedulerShareCompleted ? 'mdi-check-circle' : 'mdi-share-variant' }}</v-icon>
                    <span class="tutorial-step">Step 4</span>
                    <span class="tutorial-title">シェア機能</span>
                  </div>
                </v-btn>
              </v-col>
            </v-row>

          </v-card-text>

          <v-card-actions class="pa-6 pt-2" style="position: relative; z-index: 1;">
            <v-btn
              rounded
              outlined
              large
              class="px-6"
              style="border: 2px solid rgba(255,255,255,0.3); color: rgba(255,255,255,0.9); transition: all 0.3s ease; text-transform: none; font-weight: 500;"
              @click="tutorialDialog = false"
            >
              <v-icon left size="20">mdi-arrow-left</v-icon>
              <span>戻る</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ログアウトダイアログ -->
      <v-dialog
        v-model="logoutDialog"
        max-width="420"
        transition="dialog-bottom-transition"
        overlay-color="#1a1f33"
        overlay-opacity="0.8"
      >
        <v-card
          class="pa-6 rounded-xl elevation-12"
          style="background: linear-gradient(135deg, #2c3e70, #4b53a0); color: #fff;"
        >
          <v-card-title class="justify-center">
            <v-icon color="cyan lighten-3" size="52" class="mr-2">mdi-logout</v-icon>
            <span class="text-h6 font-weight-bold">ログアウトしますか？</span>
          </v-card-title>

          <v-card-text class="text-center mt-3 mb-2" style="color: #e0e0e0;">
            <p>再度ログインが必要になります。</p>
          </v-card-text>

          <v-card-actions class="justify-center mt-4">
            <v-btn
              text
              rounded
              class="px-6 py-2"
              style="color: #b0bec5;"
              @click="logoutDialog = false"
            >
              <v-icon left small>mdi-close</v-icon>キャンセル
            </v-btn>

            <v-btn
              rounded
              class="px-6 py-2 ml-3"
              style="background: linear-gradient(135deg, #536dfe, #8e24aa); color: white;"
              elevation="3"
              @click="signOutWrap"
            >
              <v-icon left small>mdi-logout</v-icon>ログアウト
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer/>

    </v-list>

  </v-navigation-drawer>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiRobotHappy, mdiCommentQuestion } from '@mdi/js'; // mdiRobotHappyとmdiCommentQuestionをインポート

export default {
  components: {
    SvgIcon, // SvgIconコンポーネントを登録
  },
  data: () => ({
    logoutDialog: false,
    contactDialog: false, // お問い合わせフォームダイアログの状態
    tutorialDialog: false, // チュートリアル選択ダイアログの状態
    manualLink: "https://ebay-marketing-tool.com/expo-manual/",
    val: false,
    adminOnly: ["/processor", "/parser", "/dashboard"],
    mdiRobotHappy: mdiRobotHappy,
    mdiCommentQuestion: mdiCommentQuestion, // mdiCommentQuestionをdataプロパティで利用可能にする
    hubspotScriptLoaded: false, // HubSpotスクリプトが読み込まれたか追跡
    tutorialCompleted: false, // チュートリアル完了状態
    schedulerShareCompleted: false, // シェア機能チュートリアル完了状態
    schedulerTutorialCompleted: false, // 定期設定チュートリアル完了状態
    extractTutorialCompleted: false, // データ収集チュートリアル完了状態
    counterUnsubscribe: null, // Firebaseリスナーのクリーンアップ用
    mainContents: [
      {title: "テンプレート", link: "/template-main", icon: "mdi-file-document-outline", color: ""},
      {title: "結果確認", link: "/scheduler-result-list", icon: "mdi-file-clock", color: ""},
      {title: "データ収集", link: "/extract-histories", icon: mdiRobotHappy, color: ""},
      {title: "定期設定", link: "/scheduler-main", icon: "mdi-clock-outline", color: ""},
      {title: "Dashboard", link: "/dashboard", icon: "mdi-view-dashboard-variant", color: ""},
      {title: "Processor", link: "/processor", icon: "mdi-database-edit", color: ""},
      {title: "Parser", link: "/parser", icon: "mdi-laptop", color: ""},
      // 「お問い合わせ」をメインコンテンツに直接追加すると、
      // v-forのobj.linkに基づいてルーティングされるため、別途v-list-itemとして定義
      // もしv-forの中に入れたい場合は、linkプロパティを処理するカスタムロジックが必要
    ]
  }),
  methods: {
    setupTutorialListener(uid) {
      const docRef = this.doc(this.db, "counter", uid);
      this.counterUnsubscribe = this.onSnapshot(docRef, (snap) => {
        if (snap.exists()) {
          const data = snap.data();
          this.tutorialCompleted = data?.tutorial_checker?.result_view_template === true;
          this.schedulerShareCompleted = data?.tutorial_checker?.scheduler_share === true;
          this.schedulerTutorialCompleted = data?.tutorial_checker?.scheduler_tutorial === true;
          this.extractTutorialCompleted = data?.tutorial_checker?.extract_tutorial === true;
        } else {
          this.tutorialCompleted = false;
          this.schedulerShareCompleted = false;
          this.schedulerTutorialCompleted = false;
          this.extractTutorialCompleted = false;
        }
      }, (error) => {
        console.error("Error listening to counter document:", error);
      });
    },
    async initializeTutorialChecker() {
      try {
        const uid = this.users?.uid;
        if (!uid) return;

        // counter/uidからデータを取得
        const counterData = await this.getDocument(["counter", uid], true);
        
        // tutorial_checkerが存在しない場合のみ初期化
        if (!counterData?.tutorial_checker) {
          const now = this.yyyy_mm_dd_hh_mm_ss();
          const tutorialChecker = {
            extract_tutorial: false,
            result_view_template: false,
            scheduler_share: false,
            scheduler_tutorial: false,
            created_at: now,
            updated_at: now
          };
          
          await this.setDocument(
            ["counter", uid],
            { tutorial_checker: tutorialChecker },
            true
          );
        }
      } catch (error) {
        console.error("Failed to initialize tutorial_checker:", error);
      }
    },
    async openTutorialDialog() {
      // tutorial_checkerが存在しない場合に初期化
      await this.initializeTutorialChecker();
      // ダイアログを開く
      this.tutorialDialog = true;
    },
    signOutWrap() {
      this.logoutDialog = false;
      this.$store.dispatch("state/setUser", {uid: null});
      this.auth.signOut()
      this.$router.push(`/`)
      this.$store.dispatch("state/switchDrawer", false);
      this.$store.dispatch("state/switchIsLoggedIn", false);
    },
    toggleDrawer() {
      this.$store.dispatch("state/switchDrawer", !this.isOnDrawer);
    },
    startTutorial(type) {
      if (type === 'scheduler' && !this.isStep3Enabled) {
        return;
      }
      
      this.tutorialDialog = false;
      
      // チュートリアルタイプに応じて遷移先を決定
      const routes = {
        'scheduler': { path: '/scheduler-main', query: { tutorial: 'true' } },
        'extract': { path: '/extract-histories', query: { tutorial: 'true', mode: 'extract' } },
        'share': { path: '/scheduler-main', query: { tutorial: 'true', mode: 'share' } },
        'result': { path: '/scheduler-result-list', query: { tutorial: 'true' } }
      };
      
      const route = routes[type];
      if (route) {
        // 現在のルートと同じ場合は遷移しない
        const currentRoute = this.$route.path;
        const currentQuery = this.$route.query;
        const targetPath = route.path;
        const targetQuery = route.query;
        
        if (currentRoute === targetPath && JSON.stringify(currentQuery) === JSON.stringify(targetQuery)) {
          // 既に同じURLにいる場合は何もしない
          return;
        }
        
        this.$router.push(route).catch(err => {
          // 重複ナビゲーションエラーを無視
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        });
      }
    },
    startShareTutorial() {
      if (!this.isStep4Enabled) {
        return;
      }
      
      this.tutorialDialog = false;
      
      // シェア機能のチュートリアル: /scheduler-main?tutorial=true&mode=share に遷移
      const route = { path: '/scheduler-main', query: { tutorial: 'true', mode: 'share' } };
      
      // 現在のルートと同じ場合は遷移しない
      const currentRoute = this.$route.path;
      const currentQuery = this.$route.query;
      const targetPath = route.path;
      const targetQuery = route.query;
      
      if (currentRoute === targetPath && JSON.stringify(currentQuery) === JSON.stringify(targetQuery)) {
        // 既に同じURLにいる場合は何もしない
        return;
      }
      
      this.$router.push(route).catch(err => {
        // 重複ナビゲーションエラーを無視
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },
    startResultTutorial() {
      this.tutorialDialog = false;
      
      // 結果確認のチュートリアル: /template-main?tutorial=true に遷移
      const route = { path: '/template-main', query: { tutorial: 'true' } };
      
      // 現在のルートと同じ場合は遷移しない
      const currentRoute = this.$route.path;
      const currentQuery = this.$route.query;
      const targetPath = route.path;
      const targetQuery = route.query;
      
      if (currentRoute === targetPath && JSON.stringify(currentQuery) === JSON.stringify(targetQuery)) {
        // 既に同じURLにいる場合は何もしない
        return;
      }
      
      this.$router.push(route).catch(err => {
        // 重複ナビゲーションエラーを無視
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },
    startExtractTutorial() {
      if (!this.isStep2Enabled) {
        return;
      }
      
      this.tutorialDialog = false;
      
      // データ収集のチュートリアル: /extract-histories?tutorial=true&mode=extract に遷移
      const route = { path: '/extract-histories', query: { tutorial: 'true', mode: 'extract' } };
      
      // 現在のルートと同じ場合は遷移しない
      const currentRoute = this.$route.path;
      const currentQuery = this.$route.query;
      const targetPath = route.path;
      const targetQuery = route.query;
      
      if (currentRoute === targetPath && JSON.stringify(currentQuery) === JSON.stringify(targetQuery)) {
        // 既に同じURLにいる場合は何もしない
        return;
      }
      
      this.$router.push(route).catch(err => {
        // 重複ナビゲーションエラーを無視
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    }
  },
  computed: {
    isOnDrawer() {
      return this.$store.getters["state/storeDrawerFlag"]
    },
    users() {
      return this.$store.getters["state/storeUser"]
    },
    isLoggedIn () {
      return this.$store.getters["state/storeIsLoggedIn"]
    },
    dynamicDrawerWidth() {
      const allTitles = [
        ...this.mainContents.map(item => item.title),
        "MyPage",
        "チュートリアル", // チュートリアルも幅の計算に含める
        "お問い合わせ", // お問い合わせも幅の計算に含める
        "Logout"
      ];
      
      const maxTitleLength = Math.max(...allTitles.map(title => title.length));
      const calculatedWidth = maxTitleLength * 10 + 70;
      const minWidth = 180;
      return Math.max(calculatedWidth, minWidth);
    },
    isStep2Enabled() {
      return this.tutorialCompleted;
    },
    isStep3Enabled() {
      return this.extractTutorialCompleted;
    },
    isStep4Enabled() {
      return this.schedulerTutorialCompleted;
    }
  },
  watch: {
    users: {
      handler(newUsers) {
        // 既存のリスナーをクリーンアップ
        if (this.counterUnsubscribe) {
          this.counterUnsubscribe();
          this.counterUnsubscribe = null;
        }
        
        // uidが利用可能になったらFirebaseリスナーを設定
        const uid = newUsers?.uid;
        if (uid) {
          this.setupTutorialListener(uid);
        } else {
          // ログアウト時など、uidがなくなった場合は状態をリセット
          this.tutorialCompleted = false;
          this.schedulerShareCompleted = false;
          this.schedulerTutorialCompleted = false;
          this.extractTutorialCompleted = false;
        }
      },
      immediate: true // 初期値でも実行
    }
  },
  beforeDestroy() {
    // Clean up Firebase listener
    if (this.counterUnsubscribe) {
      this.counterUnsubscribe();
      this.counterUnsubscribe = null;
    }
  }
}
</script>

<style scoped>
/* ボタンの順次フェードイン・スライドインアニメーション */
.tutorial-btn-1 {
  animation: slideInFade 0.5s ease-out 0.1s both;
}

.tutorial-btn-2 {
  animation: slideInFade 0.5s ease-out 0.2s both;
}

.tutorial-btn-3 {
  animation: slideInFade 0.5s ease-out 0.3s both;
}

.tutorial-btn-4 {
  animation: slideInFade 0.5s ease-out 0.4s both;
}

@keyframes slideInFade {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* アイコンのパルスアニメーション */
.tutorial-icon {
  animation: iconPulse 2s ease-in-out infinite;
  transition: transform 0.3s ease;
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* ホバー時のアニメーション強化 */
.tutorial-btn:hover {
  transform: translateY(-4px) scale(1.02) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;
  background: rgba(255,255,255,0.25) !important;
  border-color: rgba(255,255,255,0.4) !important;
  animation-play-state: paused;
}

.tutorial-btn:hover .tutorial-icon {
  transform: scale(1.2) rotate(5deg) !important;
  animation: iconSpin 0.6s ease-in-out;
}

@keyframes iconSpin {
  0% {
    transform: scale(1.1) rotate(0deg);
  }
  50% {
    transform: scale(1.2) rotate(10deg);
  }
  100% {
    transform: scale(1.2) rotate(5deg);
  }
}

/* クリック時のアニメーション */
.tutorial-btn:active {
  transform: translateY(-1px) scale(0.98) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
}

.tutorial-btn:active .tutorial-icon {
  transform: scale(0.95) !important;
}

/* ボタン全体の微細な動き */
.tutorial-btn {
  position: relative;
  overflow: hidden;
}

.tutorial-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.tutorial-btn:hover::before {
  width: 300px;
  height: 300px;
}

/* カードタイトルのアニメーション */
.v-card-title {
  animation: titleFadeIn 0.6s ease-out;
}

@keyframes titleFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 背景パターンのアニメーション */
.bg-pattern-1 {
  animation: floatAnimation 8s ease-in-out infinite;
}

.bg-pattern-2 {
  animation: floatAnimation 10s ease-in-out infinite reverse;
}

@keyframes floatAnimation {
  0%, 100% {
    transform: translate(30%, -30%) scale(1);
    opacity: 0.5;
  }
  50% {
    transform: translate(35%, -25%) scale(1.1);
    opacity: 0.7;
  }
}

/* カード全体のエントランスアニメーション */
.v-card {
  animation: cardEntrance 0.5s ease-out;
}

@keyframes cardEntrance {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* ボタンの共通デザイン */
.tutorial-responsive-btn {
  background: rgba(255,255,255,0.15) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255,255,255,0.2) !important;
  color: white !important;
  border-radius: 20px !important;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2) !important;
  transition: all 0.3s ease !important;

  /* レスポンシブ高さ（画面サイズによる） */
  min-height: 120px;
  height: 20vw;    /* 画面幅の20% → 自動で大きくなる */
  max-height: 200px;
}

/* モバイルではもう少し大きくする */
@media (max-width: 600px) {
  .tutorial-responsive-btn {
    height: 32vw;
    max-height: 240px;
  }
}

/* 中身の配置 */
.tutorial-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* アイコンサイズ（レスポンシブ） */
.tutorial-icon {
  font-size: 40px !important;
}

@media (max-width: 600px) {
  .tutorial-icon {
    font-size: 48px !important;
  }
}

/* Step */
.tutorial-step {
  font-size: 12px;
  opacity: 0.8;
  margin-bottom: 2px;
}

@media (max-width: 600px) {
  .tutorial-step {
    font-size: 14px;
  }
}

/* タイトル */
.tutorial-title {
  font-size: 16px;
  font-weight: 600;
}

@media (max-width: 600px) {
  .tutorial-title {
    font-size: 18px;
  }
}

/* チュートリアル完了状態のスタイル */
.tutorial-completed {
  background: rgba(12, 236, 23, 0.547) !important;
  border-color: rgba(76, 175, 81, 0.6) !important;
  position: relative;
  box-shadow: 0 4px 12px rgba(76, 175, 81, 0.2) !important;
}

.tutorial-completed::after {
  content: '';
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  background: rgba(194, 247, 196, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(76, 175, 81, 0.4);
}

.tutorial-completed .tutorial-icon {
  color: rgba(212, 245, 213, 0.95) !important;
}

.tutorial-completed:hover {
  background: rgba(76, 175, 81, 0.35) !important;
  border-color: rgba(76, 175, 81, 0.75) !important;
  box-shadow: 0 6px 16px rgba(76, 175, 81, 0.3) !important;
  transform: translateY(-2px);
  transition: all 0.3s ease;
}

</style>